import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MeanderRbRoutingModule } from './lms-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularResizedEventModule } from 'angular-resize-event';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { MarkdownModule } from 'ngx-markdown';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { LmsListComponent } from './lms-list/lms-list.component';
import { LmsDetailComponent } from './lms-detail/lms-detail.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { StudentLmsReportComponent } from './student-lms-report/student-lms-report.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';




@NgModule({
  declarations: [
LmsListComponent,LmsDetailComponent, StudentLmsReportComponent
  ],
  imports: [
    CommonModule,
    MeanderRbRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatchHeightModule,
    AngularResizedEventModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    MatAutocompleteModule,
    MatChipsModule,
    NgxSpinnerModule,
    NgxDatatableModule,
    MatMenuModule,
    MarkdownModule.forRoot(),
  ]
})
export class LmsModule { }
